import { SettingsRepository } from "@/domain/repositories";
import { SettingsDataSource } from "../datasources/settings";
import { CrashInput } from "@/domain/dtos/inputs";
import { Approach, Language, Occupation } from "@/domain/entities";

export class SettingsRepoImpl implements SettingsRepository {
  constructor(private readonly dataSource: SettingsDataSource) {}

  getTermsOfUse(): Promise<any> {
    return this.dataSource.getTermsOfUse();
  }

  getTermsOfUsePsi(): Promise<string> {
    return this.dataSource.getTermsOfUsePsi();
  }

  getPrivacyPolicy(): Promise<any> {
    return this.dataSource.getPrivacyPolicy();
  }

  async getLanguages(): Promise<Language[]> {
    return this.dataSource.getLanguages();
  }

  reportCrash(params: CrashInput): Promise<void> {
    return this.dataSource.reportCrash(params);
  }

  async getOccupationAreas(query?: { page: number }): Promise<Occupation[]> {
    const data = await this.dataSource.getOccupationAreas(query);
    return data.map((elem) => ({ ...elem, selected: false }));
  }

  async getApproaches(query?: { page: number }): Promise<Approach[]> {
    const data = await this.dataSource.getApproaches(query);
    return data.map((elem) => ({ ...elem, selected: false }));
  }
}
